<template>
  <FormSection class="text-center pt-7">
    <BaseAlert
      v-if="!isValid"
      class="mb-9"
      type="error"
      :message="$t('form.error.fillAllRequiredFields')"
    />

    <div :class="$style['button-wrapper']">
      <BaseButton v-if="prevStep" type="secondary" :disabled="isPending" @click.native="prevStep">{{
        $t('form.prevStep')
      }}</BaseButton>

      <BaseButton v-if="nextStep" :disabled="isPending || !isValid" @click.native="nextStep">{{
        $t('form.nextStep')
      }}</BaseButton>

      <BaseButton
        v-else-if="finishStep"
        :disabled="isPending || !isValid"
        @click.native="finishStep"
        >{{ $t('form.finishStep') }}</BaseButton
      >
    </div>

    <span v-if="hasRequiredFields" class="mt-9" :class="$style.info">
      {{ $t('form.mandatoryField') }}
    </span>
  </FormSection>
</template>

<script>
import StepperMixin from '@/js/mixins/stepper-mixin.js'

import FormSection from '@/js/components/Forms/FormSection.vue'

export default {
  name: 'FormStepperControls',
  components: { FormSection },
  props: {
    ...StepperMixin.props,
    isValid: {
      type: Boolean,
      default: true,
    },
    isPending: Boolean,
    hasRequiredFields: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss" module>
.info {
  display: block;

  color: var(--red);
  font-size: var(--font-sm);
  text-align: left;
}

.button-wrapper {
  display: grid;
  grid-gap: 2rem;
  grid-template-columns: repeat(auto-fit, minmax(8rem, max-content));
  justify-content: center;
}
</style>
